import type { PropsWithChildren } from "react";
import { getSupportedPivotAggregationTypes, supportedPivotAggregations } from "../../../utilities/aggregationHelper.ts";
import { SupportedAggregationsContextProvider } from "../../viewer/common/context/SupportedAggregationsContextProvider.tsx";

export default function PivotContainer({ children }: PropsWithChildren) {
  return (
    <SupportedAggregationsContextProvider
      aggregations={supportedPivotAggregations}
      getSupportedAggregationTypes={getSupportedPivotAggregationTypes}
    >
      {children}
    </SupportedAggregationsContextProvider>
  );
}
